import React from 'react';
import {
    Create,
    Datagrid,
    DeleteButton,
    FileField, FileInput,
    List,
    SimpleForm,
    useTranslate
} from 'react-admin';
import BackButton from '../components/BackButton';
import { API_URL } from '../variables/constant';


export const GuideConducteur1List = props => {
    console.log(``)
    const translate = useTranslate();
    return (
        <List {...props}
              filter={{ guideConducteur1: { "neq": null } }}
              sort={{ field: "updatedAt", order: "DESC" }}>
            <Datagrid>
                <FileView guide="guideConducteur1"/>
                <DeleteButton />
            </Datagrid>
        </List>
    )
};

const FileView = (props) => {
    return (
        <div>
        <a href={`${API_URL}/Containers/pdf/download/${props.record.guideConducteur1}`}>{props.record.guideConducteur1}</a>
        </div>
    )
}

const CustomForm = (props) => {
    const translate = useTranslate();
    return (
        <div className="w-100">
            <div className="d-flex flex-wrap">
                <div className="col-12">
                    <FileInput source="guideConducteur1" label="Related files" accept="application/pdf">
                        <FileField source="guideConducteur1" title="guideConducteur1" />
                    </FileInput>
                </div>
            </div>
        </div>
    )
};

export const GuideConducteur1Create = (props: any) => {
    const translate = useTranslate();
    return (
        <div>
            <div className="d-flex justify-content-between align-items-center mt-3">
                <BackButton/>
                <h3>{translate('guide.create')}</h3>
                <b></b>
            </div>
            <Create {...props}>
                <SimpleForm redirect="/GuideConducteur1">
                    <CustomForm/>
                </SimpleForm>
            </Create>
        </div>
    );
};

